import { useState } from 'react';
import './main.css';
import { getWlpOptions, useWlpData } from '../config/wlp';
import { Dropdown } from 'react-bootstrap';

export default function EnvBanner() {
  const [dropdownName, setDropdownName] = useState('WLP Styling');
  const [themeName, setThemeName] = useState(window.location.host);

  useWlpData(themeName);

  if (process.env.REACT_APP_ENV === 'prod') return null;

  const setStyling = (wlp) => {
    setDropdownName(wlp.name || 'CABIE');
    setThemeName(wlp.url);
  };

  const WlpOptions = getWlpOptions();

  return (
    <>
      {process.env.REACT_APP_ENV === 'dev' && (
        <div className="env-banner w-100 d-flex bold alert-success justify-content-center align-items-center">
          <Dropdown title="WLP theme select" className="theme-select-dropdown position-absolute top-0 start-0">
            <Dropdown.Toggle id="dropdown-basic">{dropdownName}</Dropdown.Toggle>
            <Dropdown.Menu>
              {WlpOptions.map((wlp) => {
                return (
                  <Dropdown.Item key={wlp.name} onClick={() => setStyling(wlp)}>
                    {wlp.name}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
          <span style={{ fontSize: '28px', color: 'red' }}>** DEV Environment **</span>
          &nbsp;
        </div>
      )}

      {process.env.REACT_APP_ENV === 'test' && (
        <div className="env-banner w-100 d-flex bold alert-danger justify-content-center align-items-center">
          <span style={{ fontSize: '28px', color: 'red' }}>** UAT Environment **</span>
          &nbsp;
          {/* UAT ENVIRONMENT - FOR TESTING ONLY - NO LIVE JOBS! */}
        </div>
      )}

      {process.env.REACT_APP_ENV === 'demo' && (
        <div
          style={{ backgroundColor: '#b4b4b4' }}
          className="w-100 d-flex bold justify-content-center align-items-center"
        >
          <span></span> &nbsp;Customer Demo Platform
        </div>
      )}
    </>
  );
}
